import {takeLatest, takeEvery} from "redux-saga";
import {fork, put, call} from "redux-saga/effects";
import * as AuthApi from "../lib/api/AuthApi";
import MessageBus from "../lib/MessageBus";
import {
  SHOW_LOGIN,
  CHECK_LOGIN,
  CHECK_LOGGED_IN,
  LOGOUT,
  LOGIN_OR_REDIRECT,
  loginSuccess,
  loginFailed,
  logoutSuccess
} from "../actions/AuthActions";


function doLogin(baseAction) {
  AuthApi.authorize();
}

function* doLogout(baseAction) {
  AuthApi.logout();
  yield put(logoutSuccess());
}

function* doCheckLogin(baseAction) {
  const {success, failure} = yield call(AuthApi.checkAuth);
  if (success) {
    const decodedToken = AuthApi.getDecodedToken();
    yield put(loginSuccess(AuthApi.getScopes(decodedToken), AuthApi.getUserMetadata(decodedToken)));
    MessageBus.publish("navigation", "goto", {
      url: "/"
    })        
  } else {
    yield call(AuthApi.logout);
    yield put(loginFailed(failure));
  }
}

function* doCheckLoggedIn(baseAction) {
  if (AuthApi.isAuthenticated()) {
    const decodedToken = AuthApi.getDecodedToken();
    yield put(loginSuccess(AuthApi.getScopes(decodedToken), AuthApi.getUserMetadata(decodedToken)));
    MessageBus.publish("navigation", "goto", {
      url: "/"
    })    
  }
  // Otherwise do nothing.
}

function* doLoginOrRedirect(baseAction) {
  if (AuthApi.isAuthenticated()) {
    const decodedToken = AuthApi.getDecodedToken();
    yield put(loginSuccess(AuthApi.getScopes(decodedToken), AuthApi.getUserMetadata(decodedToken)));
    MessageBus.publish("navigation", "goto", {
      url: baseAction.pathname
    })
  } else {
    MessageBus.publish("navigation", "goto", {
      url: "/login"
    })
  }
}

function* watchLogin() {
  yield takeLatest(SHOW_LOGIN, doLogin);
}

function* watchLogout() {
  yield takeLatest(LOGOUT.LOGOUT, doLogout);
}

function* watchCheckLogin() {
  yield takeEvery(CHECK_LOGIN, doCheckLogin);
}

function* watchCheckLoggedIn() {
  yield takeLatest(CHECK_LOGGED_IN, doCheckLoggedIn);
}

function* watchLoginOrRedirect() {
  yield takeLatest(LOGIN_OR_REDIRECT, doLoginOrRedirect);
}

export default function* authSaga() {
  yield fork(watchLogin);
  yield fork(watchLoginOrRedirect);
  yield fork(watchCheckLogin);
  yield fork(watchCheckLoggedIn);
  yield fork(watchLogout);
}
